import { cn } from '@/utils/shad';

/** Default skeleton row count for tables without pagination. */
export const DEFAULT_TABLE_SKELETON_ROW_COUNT = 10;

/** Shared table shell for report-aligned ROI tables (matches ReportDatatableChart column rules). */
export const REPORT_DATATABLE_TABLE_CLASSNAME = cn(
  'w-full table-fixed border-collapse',
  '[&_thead_tr_th]:border-r [&_thead_tr_th]:border-r-lightborder',
  '[&_tbody_tr_td]:border-r [&_tbody_tr_td]:border-r-lightborder',
);

/**
 * Zebra striping for skeleton rows inside a `TableBody striped={false}` — tables that stripe rows
 * manually (e.g. the report datatable, whose nested rows must follow the parent row color).
 * Tints the 1st, 3rd, … row and lets the others fall through to the surface behind the table,
 * matching how those tables color their real rows.
 */
export const TABLE_SKELETON_STRIPED_ROW_CLASS = 'odd:bg-[#0E0E0E]';
